export default __webpack_public_path__ + "static/media/chat.fe01d63e.svg";